module.exports = __webpack_public_path__ + "img/prev-disable.ea63c6ff.svg";